<script>
import { mapActions, mapGetters } from 'vuex'
import { TYPES as LEAD_CONTACT_TYPES } from './store'
import { TYPES as CNT_ORG_TYPES } from '../../../organization-contact/store'
import { ROUTES as LEAD_ORG_ROUTES } from '../../../organization/organization/lead-organization/router'
import { ROUTES as LEAD_CONTACT_ROUTES } from './router'
import { ORGANIZATION_CUSTOMER_TYPE_CODE, ORGANIZATION_CUSTOMER_LEAD_CODE } from '@/const'

import ContactDetailMixin from '../../../components/contact/mixins/ContactDetailMixin'

export default {
  name: 'LeadContactDetail',
  mixins: [ContactDetailMixin],
  data () {
    return {
      LEAD_ORG_ROUTES,
      LEAD_CONTACT_ROUTES,
      organizationTitle: 'Extra organization',
      routeNameOrganizationDetail: LEAD_ORG_ROUTES.LEAD_ORGANIZATION_DETAIL,
      title: 'Extra contact',
      titleList: 'Extra organizations contacts',
      orgType: ORGANIZATION_CUSTOMER_TYPE_CODE,
      orgCode: ORGANIZATION_CUSTOMER_LEAD_CODE
    }
  },
  computed: {
    ...mapGetters({
      ...LEAD_CONTACT_TYPES.GENERIC.organization.customercontact.DETAIL.GETTERS
    }),
    showDocumentsButton () {
      return true
    }
  },
  methods: {
    ...mapActions({
      ...LEAD_CONTACT_TYPES.GENERIC.organization.customercontact.DETAIL.ACTIONS,
      getContactList: LEAD_CONTACT_TYPES.GENERIC.organization.customercontact.LIST.ACTIONS.getList,
      createOrganizationContact: CNT_ORG_TYPES.GENERIC.organization.organizationcontact.DETAIL.ACTIONS.create
    }),
    goToOrganizationDetail () {
      this.$router.push({ name: LEAD_ORG_ROUTES.LEAD_ORGANIZATION_DETAIL, params: { id: this.$route.params.id } })
    },
    goToList () {
      this.$router.push({ name: LEAD_CONTACT_ROUTES.LEAD_CONTACT_LIST })
    }
  }
}
</script>
